import PageElement from './PageElement';
import PageElementDefinition from './PageElementDefinition';
import PageElementMetaData from './PageElementMetaData';

export default {
  PageElement: PageElement,
  PageElementDefinition: PageElementDefinition,
  PageElementType: PageElementMetaData.type,
  PageElementId: PageElementMetaData.id
};
